import { render, staticRenderFns } from "./loaderComponent.vue?vue&type=template&id=112a97ea"
import script from "./loaderComponent.vue?vue&type=script&lang=js"
export * from "./loaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports